import React from 'react';
import { ReactComponent as Logo } from '../../assets/logo-text.svg';

const LogoIcon = (props) => {
  return <Logo {...props} />;
};

export default LogoIcon;
